module.exports = __webpack_public_path__ + "static/media/details-22-image-6.45239273.jpg";